<template>
  <Login @login="handleLoginEvent" />
</template>

<script>
import Login from '@/components/views/login.vue';
import { getUrlParam } from '@/utils';
import { TEMPLATE_NAME } from '../constants';
export default {
  components: { Login },
  methods: {
    handleLoginEvent(isLoginSuccess) {
      if (isLoginSuccess) {
        const tplCode = getUrlParam('tpl');
        this.visitLog('', '', {
          actEventType: 'lottery_login',
          module_name: `${TEMPLATE_NAME[tplCode] || ''}登录`,
          activity_id: getUrlParam('code'),
          is_share_link: getUrlParam('fromShare') ? 1 : 0
        });
      }
    }
  }
};
</script>
